import { render } from "./ClientsRankingLastPurchase.vue?vue&type=template&id=0ae24072&ts=true"
import script from "./ClientsRankingLastPurchase.vue?vue&type=script&lang=ts"
export * from "./ClientsRankingLastPurchase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__